export default __webpack_public_path__ + "static/media/magnifying-glass.694540df.svg";